import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import * as color from '@constant/color';
import * as size from '@constant/size';
import TextBlock from '@component/common/block/text-block';
import ImageBlock from '@component/common/block/image-block';
import Gap from '@component/common/gap';
import otterReadImage from '@asset/image/otter-read.png';
import { IYAGIGO_TODAY_INIT_DATA_MIN_TIME } from '@constant/iyagigo/variable';

const PROGRESS_FILL_BUFFER_MS = 500;
const PROGRESS_DURATION_MS = Math.max(IYAGIGO_TODAY_INIT_DATA_MIN_TIME - PROGRESS_FILL_BUFFER_MS, 0);

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding-top: var(--sat);
  padding-bottom: var(--sab);
  z-index: 9999;
  background-color: ${color.BROWN_4};
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
`;

const ProgressBarTrack = styled.div`
  width: 200px;
  height: 8px;
  background-color: ${color.GRAY_2};
  border-radius: 4px;
  overflow: hidden;
`;

const ProgressBarFill = styled.div<{ $progress: number; $durationMs: number }>`
  width: 100%;
  height: 100%;
  background-color: ${color.BROWN_2};
  transform-origin: left center;
  transform: scaleX(${(props) => props.$progress / 100});
  transition: transform ${(props) => props.$durationMs}ms linear;
  will-change: transform;
`;

const TodayDataInitScreen: React.FC = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timeoutId = setTimeout(() => setProgress(100), 50);
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <Wrapper>
      <ImageBlock
        src={otterReadImage}
        alt='오늘의 학습 준비 중'
        design={{ image: { width: '120px', height: '120px' } }}
      />
      <Gap height={size.MARGIN_2} />
      <TextBlock
        text='오늘의 학습을 준비하고 있어요'
        design={{ text: { size: 'large', color: color.BLACK_2, bold: true } }}
      />
      <Gap height={'5px'} />
      <TextBlock text='함께 한 걸음 더 나아가요' design={{ text: { size: 'medium', color: color.GRAY_1, bold: false } }} />
      <Gap height={size.MARGIN_2} />
      <ProgressBarTrack>
        <ProgressBarFill $progress={progress} $durationMs={PROGRESS_DURATION_MS} />
      </ProgressBarTrack>
    </Wrapper>
  );
};

export default TodayDataInitScreen;
